/* eslint-disable no-plusplus, no-param-reassign */
/* global _ */

import Modernizr from 'modernizr';

export default {
  cache() {
    this.$html = $('html');
    this.$body = $(document.body);
    this.$blogPagination = $('.js-blog-pagination');
    this.$blueimpGallery = $('#blueimp-gallery');
    this.$searchBox = $('.js-search-box');
    this.$stickyNavi = $('.js-sticky-navi');
    this.$slideMenuToggle = $('.js-slide-menu-toggle');
    this.$slideMenuContainer = $('.js-slide-menu-container');
    this.prevScroll = 0;
  },
  init() {
    // Build cache
    this.cache();

    // Slide menu toggle
    this.$slideMenuToggle.one('click', { home: this }, this.toggleSlideMenu);

    // Search box hover and focus effects
    this.$searchBox.focus((e) => {
      e.target.parentNode.classList.add('is-active');
    });

    this.$searchBox.blur((e) => {
      e.target.parentNode.classList.remove('is-active');
    });

    this.$searchBox.hover((e) => {
      e.target.parentNode.classList.toggle('mouse-over');
    });

    // Init sticky navigation
    // Lodash debounce, so we don't fire sticky related code endlessly.
    const debouncedStickyNaviControl = _.debounce(this.stickyNaviControl, 50, {
      leading: false,
      trailing: true,
      maxWait: 250,
    });

    // Initialise the sticky navigation functionality.
    window.addEventListener('scroll', () => {
      debouncedStickyNaviControl(this);
    });

    // Trigger from ./home.js, closes mobile menu on gallery filtering.
    if (this.$body.hasClass('home')) {
      this.$body.on('galleryChange', () => {
        if (this.$slideMenuContainer.is(':visible')) {
          this.$slideMenuToggle.click();
        }
      });
    }

    // Check if we need to change pagination urls for single posts.
    if (this.$blogPagination.length > 0 && this.$blogPagination.eq(0).data('toggle')) {
      const toggle = this.$blogPagination.eq(0).data('toggle');

      this.$blogPagination.find('a').each((i, el) => {
        const $anchor = $(el);
        const $href = $anchor.attr('href');
        $anchor.attr('href', `${$href}?${toggle}=true`);
      });
    }

    // Init blueimp gallery if needed.
    if (!this.$body.hasClass('home') && this.$blueimpGallery.length > 0) {
      this.initBlueimpGallery();
    }
  },
  toggleSlideMenu(e) {
    const home = e.data.home;
    const svgs = e.currentTarget.getElementsByTagName('svg');
    const slideDuration = 300; // @ref01 if changing this, change also in ./home.js
    home.$html.velocity('scroll', {
      offset: 0,
      duration: window.pageYOffset || document.documentElement.scrollTop ? 300 : 0,
      complete() {
        if (Modernizr.mq('(max-width: 1219px)')) {
          for (let i = 0, len = svgs.length; i < len; i++) {
            svgs[i].classList.toggle('is-active');
          }

          // Toggle slide menu
          if (home.$stickyNavi.toggleClass('is-locked').hasClass('is-locked')) {
            home.$slideMenuContainer.velocity('slideDown', { duration: slideDuration });
          } else {
            home.$slideMenuContainer.velocity('slideUp', { duration: slideDuration });
          }
        }
      },
    });

    setTimeout(() => {
      home.$slideMenuToggle.one('click', { home }, home.toggleSlideMenu);
    }, 500);
  },
  stickyNaviControl(home) {
    const scrollFromTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyOn = 200;

    if (home.$stickyNavi.hasClass('is-locked')) {
      return;
    }

    if (scrollFromTop >= stickyOn) {
      home.$stickyNavi.addClass('is-active');
      if (scrollFromTop < home.prevScroll) {
        home.$stickyNavi.addClass('is-visible');
      } else {
        home.$stickyNavi.removeClass('is-visible');
      }
    } else if (home.$stickyNavi.hasClass('is-active')) {
      home.$stickyNavi.removeClass('is-visible');
      setTimeout(() => {
        home.$stickyNavi.removeClass('is-active');
      }, 350);
    }

    home.prevScroll = scrollFromTop;
  },
  initBlueimpGallery() {
    this.$blueimpGallery
      // Check if the current open lightbox image has a caption, and apply it if needed.
      .on('slide', function checkCaption(e, index, slide) {
        const galleryData = $(this).data('gallery');

        if (slide && !slide.getAttribute('data-caption')) {
          const caption = galleryData.list[index].getAttribute('data-caption');
          if (caption) {
            slide.setAttribute('data-caption', caption);
          }
        }
      })
      // Toggle caption visibility.
      .click((e) => {
        let captionTarget;

        if (e.target.classList.contains('slide')) {
          captionTarget = e.target;
        } else if (e.target.classList.contains('slide-content')) {
          captionTarget = e.target.parentNode;
        }

        if (captionTarget && captionTarget.getAttribute('data-caption')) {
          captionTarget.classList.toggle('show-info');
        }
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js